module.exports = __webpack_public_path__ + "static/media/btn1.d0625f4c.jpg";